Ext.define('SA.view.TableState', {
    constructor() {
        this.trackIds = null;
        this.containerSize = null;
        this.dragColId = null;
    },

    clearDragColId() {
        this.setDragColId(null);
    },

    getContainerSize() {
        return this.containerSize;
    },

    getDragColId() {
        return this.dragColId;
    },

    getTrackIds() {
        return this.trackIds;
    },

    hasTrackIds() {
        return this.getTrackIds() !== null;
    },

    isDragging() {
        return this.getDragColId() !== null;
    },

    setContainerSize(containerSize) {
        this.containerSize = containerSize;
    },

    setDragColId(dragColId) {
        this.dragColId = dragColId;
    },

    setTrackIds(trackIds) {
        this.trackIds = trackIds;
    }
});